import RedirectExternal from '#client/components/RedirectExternal';
import { useLeadDetails } from '#client/hooks/useLeadDetails';
import { generateShoppingUiRedirectUrl } from '#client/utils/urls';

/**
 * This component is used to redirect orphan accounts to shopping-ui
 * using lead details to restore the flow state (if available).
 *
 * @returns {import('react').ReactElement} - The redirect component with shopping-ui URL
 */
const OrphanAccountRedirect = () => {
  const { data: leadDetails, loading } = useLeadDetails();

  if (loading) {
    return null;
  }

  const redirectUrl = generateShoppingUiRedirectUrl(leadDetails);
  return <RedirectExternal href={redirectUrl} />;
};

export default OrphanAccountRedirect;
